import apiFetch from 'utils/apiFetch';
import {
  loadingAction,
} from '../../../store/globalState/global';


export const killThinkSeed = id => (dispatch) => {
  dispatch(loadingAction(true));
  return apiFetch('POST', { endPoint: `think-seed/${id}/kill` }).then(() => dispatch(loadingAction(false)));
};

export const launchThinkTank = ({
  id, name, description, members, socialNetworkMovement, blog, project, openInnovation,
}) => (dispatch) => {
  dispatch(loadingAction(true));
  return apiFetch('POST', { endPoint: `think-seed/${id}/launch` },
    {
      name,
      description,
      members,
      social_network_movement: socialNetworkMovement,
      blog,
      project,
      open_innovation: openInnovation,
    }).then(() => {
    dispatch(loadingAction(false));
  });
};



// WEBPACK FOOTER //
// ./src/routes/Upgrade/modules/actions.js